import React from 'react';

/**
 * Converte um subconjunto comum de Markdown (IA devolve muito ** e listas) em JSX legível.
 */
function parseBlocks(text) {
  const raw = String(text || '');
  const lines = raw.split(/\r?\n/);
  const blocks = [];
  let i = 0;
  while (i < lines.length) {
    const line = lines[i];
    if (!line.trim()) {
      i++;
      continue;
    }
    if (line.startsWith('### ')) {
      blocks.push({ type: 'h3', text: line.slice(4).trim() });
      i++;
      continue;
    }
    if (line.startsWith('## ')) {
      blocks.push({ type: 'h2', text: line.slice(3).trim() });
      i++;
      continue;
    }
    if (line.startsWith('# ')) {
      blocks.push({ type: 'h1', text: line.slice(2).trim() });
      i++;
      continue;
    }
    if (/^[-*]\s+/.test(line)) {
      const items = [];
      while (i < lines.length && /^[-*]\s+/.test(lines[i])) {
        items.push(lines[i].replace(/^[-*]\s+/, '').trim());
        i++;
      }
      blocks.push({ type: 'ul', items });
      continue;
    }
    const para = [];
    while (i < lines.length && lines[i].trim() && !/^#{1,3}\s/.test(lines[i]) && !/^[-*]\s+/.test(lines[i])) {
      para.push(lines[i]);
      i++;
    }
    blocks.push({ type: 'p', text: para.join(' ').trim() });
  }
  return blocks;
}

function formatInline(s) {
  const parts = [];
  let rest = s;
  let key = 0;
  while (rest.length) {
    const m = rest.match(/\*\*([^*]+)\*\*/);
    if (!m) {
      parts.push(<span key={key++}>{rest}</span>);
      break;
    }
    if (m.index > 0) {
      parts.push(<span key={key++}>{rest.slice(0, m.index)}</span>);
    }
    parts.push(
      <strong key={key++} className="font-semibold text-iron-accent">
        {m[1]}
      </strong>
    );
    rest = rest.slice(m.index + m[0].length);
  }
  return parts;
}

export default function IaFormattedText({
  content,
  variant = 'default',
  className = '',
}) {
  const blocks = parseBlocks(content);
  const prose =
    variant === 'compact'
      ? 'text-xs leading-relaxed text-iron-text'
      : variant === 'emphasis'
      ? 'text-sm leading-relaxed text-iron-text'
      : 'text-sm leading-relaxed text-iron-text';

  if (!blocks.length) {
    return <p className={`${prose} text-iron-muted ${className}`}>—</p>;
  }

  return (
    <div className={`space-y-3 ${prose} ${className}`}>
      {blocks.map((b, idx) => {
        if (b.type === 'h1') {
          return (
            <h3 key={idx} className="font-display text-lg tracking-wide text-iron-accent">
              {formatInline(b.text)}
            </h3>
          );
        }
        if (b.type === 'h2') {
          return (
            <h4 key={idx} className="font-display text-base text-iron-info">
              {formatInline(b.text)}
            </h4>
          );
        }
        if (b.type === 'h3') {
          return (
            <h5 key={idx} className="font-mono text-[11px] uppercase tracking-wider text-iron-muted">
              {formatInline(b.text)}
            </h5>
          );
        }
        if (b.type === 'ul') {
          return (
            <ul key={idx} className="list-disc space-y-1 pl-5 marker:text-iron-accent">
              {b.items.map((it, j) => (
                <li key={j}>{formatInline(it)}</li>
              ))}
            </ul>
          );
        }
        return (
          <p key={idx} className="whitespace-pre-wrap">
            {formatInline(b.text)}
          </p>
        );
      })}
    </div>
  );
}
